var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6911",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13402"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18206",
    d: "M1880.832 763.939a6.1 6.1 0 1 0 0 8.2",
    style: {
      strokeMiterlimit: 10,
      stroke: "#000",
      strokeLinecap: "round",
      fill: "none"
    },
    transform: "translate(-1867.435 -759.039)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13401"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 24",
    transform: "translate(8.761 9.196)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#000",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M6.457 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18207",
    d: "m1881.045 766.87 1.607 1.365-1.607 1.365",
    style: {
      strokeLinejoin: "round",
      stroke: "#000",
      strokeLinecap: "round",
      fill: "none"
    },
    transform: "translate(-1867.435 -759.039)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIc);
export default __webpack_public_path__ + "static/media/logout_ic.8308b511c1c53140a05df2d0c5c08cf7.svg";
export { ForwardRef as ReactComponent };